export default {"src":"/_next/static/media/linkedin.151f23ce.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};